// Display helpers: prices, dates, discount percentage, placeholder image

// Prices are in rupees, or in the store's own currency for stores abroad (config.currency, set once the store's
// configuration loads: StoreApp.js). Rupees keep the usual Indian format (₹1,499); other currencies use the
// country's (US$24.99, AED 149, ¥2,500).
const LOCALES = { USD: "en-US", CAD: "en-CA", GBP: "en-GB", EUR: "de-DE", AUD: "en-AU", AED: "en-AE", SAR: "en-SA", JPY: "ja-JP" };
let currency = "INR";
export const setCurrency = (code) => { currency = LOCALES[code] ? code : "INR"; };
export const money = (value) => {
    if (currency === "INR") return "₹" + Number(value || 0).toLocaleString("en-IN");
    const amount = Number(value || 0);
    const whole = currency === "JPY" || currency === "AED" || currency === "SAR" || Number.isInteger(amount);
    return new Intl.NumberFormat(LOCALES[currency], { style: "currency", currency, minimumFractionDigits: whole ? 0 : 2, maximumFractionDigits: whole ? 0 : 2 }).format(amount);
};

export const formatDate = (value) => {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "" : date.toLocaleString("en-IN");
};

// Shown when a product image fails to load
export const PLACEHOLDER_IMG =
    "data:image/svg+xml;utf8," +
    encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="300"><rect width="100%" height="100%" fill="#eef3ee"/><text x="50%" y="50%" fill="#9fb3a2" font-family="Arial" font-size="20" text-anchor="middle" dominant-baseline="middle">No image</text></svg>'
    );

// Percentage off when the original price is higher than the selling price, otherwise 0
export const discountPercent = (product) =>
    product.originalPrice > product.price ? Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100) : 0;

// A smaller copy of a stock photo for small spots like product cards. Pexels and Unsplash resize from the
// `w` parameter; a pasted 1200px-wide link decodes to ~8 MB and makes the home page slow to redraw while
// scrolling. Any other address (e.g. uploaded images and the starter photos on R2) is returned unchanged.
const RESIZABLE_HOSTS = ["images.pexels.com", "images.unsplash.com"];
export const sizedImage = (url, width) => {
    try {
        const parsed = new URL(url);
        if (!RESIZABLE_HOSTS.includes(parsed.hostname)) return url;
        parsed.searchParams.set("w", String(width));
        return parsed.toString();
    } catch (err) {
        return url;
    }
};

// The first `words` words of a text, with "…" when there is more (product cards and the top of the product page;
// the full description is in the product page's description section)
export const shortText = (text, words = 20) => {
    const all = String(text || "").trim().split(/\s+/).filter(Boolean);
    return all.length > words ? `${all.slice(0, words).join(" ").replace(/[.,;:!?-]+$/, "")}…` : all.join(" ");
};
